// extracted by mini-css-extract-plugin
export default {"section":"Video_section__1RkFO","header":"Video_header__hV9Qf","videoWrapper":"Video_videoWrapper__JfZrQ","video":"Video_video__kqenN"};